
import _ from 'lodash';

const dashboardsUuid = (state) => {
  let uuids = [];
  _.forEach(state.dashboards, d=>{
    uuids.push(d.uuid);
  })
  return uuids;
}


export default {
  dashboardsUuid
};
